export const adultingColorTokens = {
  background: '#F3F6F8',
  foreground: '#261E2C',
  card: '#ffffff',
  cardForeground: '#261E2C',
  muted: '#EEF2F6',
  mutedForeground: '#655E69',
  primary: '#6B3566',
  primaryForeground: '#ffffff',
  secondary: '#5C6B47',
  secondaryForeground: '#ffffff',
  accent: '#C8922A',
  accentForeground: '#291f2e',
  success: '#2E9E6A',
  successForeground: '#ffffff',
  destructive: '#B93852',
  destructiveForeground: '#ffffff',
  border: '#D8E1E8',
  input: '#D2DBE4',
  primaryTint: '#F4EEF6',
  secondaryTint: '#EFF3ED',
  accentTint: '#FBF3E5',
  successTint: '#E8F6EF',
  destructiveTint: '#F9EAF0',
  shadow: 'rgba(24, 32, 43, 0.08)',
  overlay: 'rgba(15, 23, 42, 0.18)',
} as const;

export const adultingDarkColorTokens = {
  background: '#171317',
  foreground: '#F5F1EC',
  card: '#221D20',
  cardForeground: '#F5F1EC',
  muted: '#302930',
  mutedForeground: '#A99DA9',
  primary: '#6B3566',
  primaryForeground: '#ffffff',
  secondary: '#5C6B47',
  secondaryForeground: '#ffffff',
  accent: '#C8922A',
  accentForeground: '#1b141f',
  success: '#2E9E6A',
  successForeground: '#ffffff',
  destructive: '#B93852',
  destructiveForeground: '#ffffff',
  border: '#3A3238',
  input: '#3A3238',
  primaryTint: '#2F1C2D',
  secondaryTint: '#242C1D',
  accentTint: '#3A2B12',
  successTint: '#1b3227',
  destructiveTint: '#3C1C24',
  shadow: 'rgba(0, 0, 0, 0.28)',
  overlay: 'rgba(0, 0, 0, 0.42)',
} as const;

export const adultingSpaceTokens = {
  0: 0,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 20,
  xl: 24,
  xxl: 32,
  true: 16,
} as const;

export const adultingSizeTokens = {
  0: 0,
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
  xxl: 24,
  display: 30,
  hero: 36,
  true: 16,
} as const;

export const adultingRadiusTokens = {
  0: 0,
  xs: 6,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  pill: 999,
  true: 12,
} as const;

export const adultingZIndexTokens = {
  0: 0,
  base: 1,
  header: 10,
  overlay: 40,
  modal: 60,
  toast: 80,
  true: 1,
} as const;

export const adultingLineHeightTokens = {
  0: 0,
  xs: 16,
  sm: 20,
  md: 24,
  lg: 26,
  xl: 28,
  xxl: 32,
  display: 38,
  hero: 44,
  true: 24,
} as const;

export const adultingBodyWeightTokens = {
  0: '400',
  xs: '400',
  sm: '400',
  md: '400',
  lg: '500',
  xl: '600',
  xxl: '700',
  display: '700',
  hero: '700',
  true: '400',
} as const;

export const adultingHeadingWeightTokens = {
  0: '600',
  xs: '600',
  sm: '600',
  md: '600',
  lg: '700',
  xl: '700',
  xxl: '700',
  display: '700',
  hero: '700',
  true: '600',
} as const;

export const adultingLetterSpacingTokens = {
  0: 0,
  xs: 0,
  sm: 0,
  md: 0,
  lg: -0.08,
  xl: -0.12,
  xxl: -0.2,
  display: -0.4,
  hero: -0.6,
  true: 0,
} as const;

export const adultingNativeColors = {
  background: adultingColorTokens.background,
  surface: adultingColorTokens.card,
  surfaceMuted: adultingColorTokens.muted,
  border: adultingColorTokens.border,
  textPrimary: adultingColorTokens.foreground,
  textSecondary: adultingColorTokens.mutedForeground,
  primary: adultingColorTokens.primary,
  primaryDeep: adultingColorTokens.primary,
  secondary: adultingColorTokens.secondary,
  accent: adultingColorTokens.accent,
  success: adultingColorTokens.success,
  warning: '#8A6100',
  danger: '#b93852',
  shadow: adultingColorTokens.shadow,
  overlay: adultingColorTokens.overlay,
} as const;

export const adultingNativeSpacing = {
  xs: adultingSpaceTokens.xs,
  sm: adultingSpaceTokens.sm,
  md: adultingSpaceTokens.md,
  lg: adultingSpaceTokens.lg,
  xl: adultingSpaceTokens.xl,
} as const;
